import { PolicyVerifier } from "../policy-verifier_browser.js";
/** Verify packets according to a trust schema. */
export class TrustSchemaVerifier extends PolicyVerifier {
    policy;
    constructor(opts) {
        super({ ...opts, trustAnchors: opts.schema.trustAnchors });
        this.policy = opts.schema.policy;
    }
    checkKeyLocatorPolicy({ name }, klName) {
        const packet = this.policy.match(name);
        if (!this.policy.canSign(packet, klName)) {
            throw new Error(`${klName} cannot sign ${name}`);
        }
        return { packet };
    }
    checkCertPolicy({ name }, { name: certName }, { packet }) {
        if (!this.policy.canSign(packet, certName)) {
            /* v8 ignore next: cannot happen after checking KeyLocator */
            throw new Error(`${certName} cannot sign ${name}`);
        }
    }
}
